// Parses formatted number string to number by removing all non-numeric characters.
// Currently, this function does not support decimal numbers.
export function parseFormattedNumber(str: string | number | null | undefined): number | null {
  if (str === null || str === undefined) {
    return null;
  }

  if (typeof str === "number") {
    return str;
  }

  const cleanStr = str.replace(/[^0-9]+/g, "");
  if (cleanStr.length > 0) {
    return parseFloat(cleanStr);
  }

  return null;
}

export function formatAmountRounded(value: string | number | undefined, numberFormat: string, defaultFormat = ""): string {
  if (value === null || value === undefined || value === "" || isNaN(Number(value))) {
    return defaultFormat;
  }

  return Math.round(Number(value)).toLocaleString(numberFormat);
}

export function formatAmount(value: string | number | undefined, numberFormat: string, defaultFormat = ""): string {
  if (value === null || value === undefined || value === "" || isNaN(Number(value))) {
    return defaultFormat;
  }

  return Number(value).toLocaleString(numberFormat);
}
